import REST from 'api/rest';

class HallomartAPI extends REST {
  constructor() {
    super();
    this.baseURL = `${window.config.baseurl}wp-json/dealpay/v1`;
  }

  /**
   * Login User
   */
  login(username = '', password = '') {
    return this._request('post', 'login', null, {
      username,
      password,
      merchant: true,
    });
  }

  /**
   * Get Merchant Profile
   */
  getCurrentUser() {
    return this._request('get', 'merchant');
  }

  /**
   * Get Merchant's Products
   */
  getMerchantProducts() {
    return this._request('get', 'merchant/products');
  }

  /**
   * Get Merchant's Sold Products
   */
  getMerchantSoldProducts(page = 1) {
    return this._request('get', 'merchant/sold-products', { page });
  }

  /**
   * Request Funds Payout
   */
  requestFundsPayout(amount = 0) {
    return this._request('post', 'merchant/request-payout', null, { amount });
  }

  /**
   * Merchant Payout History
   */
  getPayoutHistory(args = {}) {
    return this._request('get', 'merchant/payout-history', args);
  }

  /**
   * Merchant Transaction History
   */
  getTransactionHistory(args = {}) {
    return this._request('get', 'merchant/transaction', args);
  }

  /**
   * Get merchant transaction graph
   */
  getTransactionGraph(args = {}) {
    return this._request('get', 'merchant/transaction/graph', args);
  }

  /**
   * Get Merchant Branches/Outlet
   */
  getMerchantBranches(args = {}) {
    return this._request('get', 'deals', args);
  }

  /**
   * Get Merchant Branch/Outlet details
   */
  getMerchantBranchDetails(id) {
    return this._request('get', `deals/${id}`);
  }
}

const api = new HallomartAPI();

export default api;



// WEBPACK FOOTER //
// ./src/api/hallomart.js